'use strict';

angular.module('cgmemApp')
  .controller('AccountViewCtrl', function ($scope, $rootScope, $state,  $stateParams, $q, $http, $log, AppConfig, WorkingAccount, User, Pass) {
		$scope.showOldTxns = false;
		$scope.previousState = $stateParams.previousState;

		$q.all([AppConfig.get(), $http.get('/api/accounts/'+$stateParams.id, {params: {transactiondetail: true, memberdetail: true}}), Pass.get($stateParams.id, "guestPass")])
		.then(function(d) {
			$scope.appConfig = d[0];
			$scope.account = d[1].data;
			$scope.guestPasses = d[2].length;
		})
		.catch(function(err) {
			$log.error("AccountViewCtrl: get accounts returned an error:",err);
			$rootScope.$emit('generalAlert', "Error retrieving account: "+err.message);
		})
		.finally(function() {
			$scope.loaded = true;
		});

		$scope.switch = function(accountId) {
			WorkingAccount.get(accountId)
			.then(function() {
				$state.go('authenticated.profile')
			});		// FIX: error check
		}
		$scope.isInGroup = User.isInGroup;
  });